import { render, staticRenderFns } from "./OppositePerson.vue?vue&type=template&id=2b3d526a&scoped=true"
import script from "./OppositePerson.vue?vue&type=script&lang=js"
export * from "./OppositePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d526a",
  null
  
)

export default component.exports